import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const exportToText = (chats) => {
  let content = "";

  chats.forEach((chat, index) => {
    const user = chat.name || chat.email || `User ${index + 1}`;
    const email = chat.email || "N/A";
    const phone = chat.phone || "N/A";
    const location = `${chat.city || "N/A"}, ${chat.country || "N/A"}`;

    // Header for each user
    content += `====================\n`;
    content += `Chat with: ${user}\n`;
    content += `Email: ${email}\n`;
    content += `Phone: ${phone}\n`;
    content += `Location: ${location}\n`;
    content += `====================\n`;

    // Q&A
    const ques = chat.ques || [];
    const answers = chat.answer || [];
    if (ques.length === 0) {
      content += `No questions found.\n\n`;
    } else {
      ques.forEach((q, i) => {
        content += `User: ${q}\n`;
        content += `Bot: ${answers[i] || "No response."}\n\n`;
      });
    }

    content += `\n\n`;
  });

  const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
  saveAs(blob, "chat_logs.txt");
};

export const exportToPDF = (chats) => {
  const doc = new jsPDF();
  let yOffset = 10;

  chats.forEach((chat, index) => {
    const user = chat.name || chat.email || `User ${index + 1}`;
    const email = chat.email || "N/A";
    const phone = chat.phone || "N/A";
    const location = `${chat.city || "N/A"}, ${chat.country || "N/A"}`;

    // Outer info table
    autoTable(doc, {
      startY: yOffset,
      head: [["Name", "Email", "Phone", "Location"]],
      body: [[user, email, phone, location]],
      styles: { fontStyle: "bold", fillColor: [220, 220, 220] },
      theme: "grid",
    });

    // Safely update yOffset
    yOffset = (doc.lastAutoTable?.finalY ?? yOffset) + 5;

    // Q&A nested table
    const rows =
      chat.ques?.map((q, i) => [q, chat.answer?.[i] || "No response."]) || [];

    if (rows.length > 0) {
      autoTable(doc, {
        startY: yOffset,
        head: [["User Query", "Bot Response"]],
        body: rows,
        styles: { fontSize: 10 },
        theme: "striped",
      });

      yOffset = (doc.lastAutoTable?.finalY ?? yOffset) + 10;
    } else {
      yOffset += 10; // move down to separate users
    }
  });

  doc.save("chat_log_nested.pdf");
};

export const exportToExcel = (chats) => {
  const data = [];

  chats.forEach((chat, index) => {
    const name = chat.name || `User ${index + 1}`;
    const email = chat.email || "N/A";
    const phone = chat.phone || "N/A";
    const city = chat.city || "N/A";
    const country = chat.country || "N/A";
    const ques = chat.ques || [];
    const answers = chat.answer || [];

    if (ques.length === 0) {
      data.push({
        Name: name,
        Email: email,
        Phone: phone,
        City: city,
        Country: country,
        UserQuery: "No questions found.",
        BotResponse: "N/A",
      });
    } else {
      ques.forEach((q, i) => {
        data.push({
          Name: name,
          Email: email,
          Phone: phone,
          City: city,
          Country: country,
          UserQuery: q,
          BotResponse: answers[i] || "No response",
        });
      });
    }
  });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Chat Logs");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, "chat_logs.xlsx");
};
